import { ResetPassword } from '../components/Authentication/ResetPassword/ResetPassword'

export const ResetPasswordPage = () => {
    return <ResetPassword />
}
